export const CR_SUBMISSION = {
    STAR_RATING: {
        HINT_SELECTOR: '.js_cr_stars-selection__hint',
        HINT_INVALID_CLASS: 'cr_stars-selection__hint--invalid',
        TITLE_SELECTOR: '.js_cr_stars-selection__title',
        TITLE_INVALID_CLASS: 'cr_stars-selection__title--invalid',
        ERROR_BANNER_SELECTOR: '.js_cr_stars-selection__error-banner',
        ERROR_BANNER_HIDDEN_CLASS: 'oc-visually-hidden',
        STARS_SELECTOR: '.js_cr_stars-selection__stars',
        RATING_INPUTS_SELECTOR: '.js_cr_stars-selection__input',
        LABEL_SELECTOR: ({ inputId }: { inputId: string }) => `label[for="${inputId}"]`,
    },
    SUBMIT: {
        BUTTON_SELECTOR: '.js_cr_submission-page_submit-button',
    },
    PAGE: {
        FORM_SELECTOR: '.js_cr_submission-page__form',
        SUCCESS_VIEW_SELECTOR: '.js_cr_submission-page__success-view',
        ACTIONS_SELECTOR: '.js_cr_submission-page__actions',
    },
} as const;
